"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgLink = function SvgLink(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("path", {
    d: 'M14.916 3.407c1.885-1.885 3.77-1.885 5.656 0 1.886 1.886 1.886 3.772 0 5.657l-5.04 5.043c-1.885 1.886-3.77 1.886-5.656 0 0 0-.707-.707 0-1.414.471-.471.943-.471 1.414 0 .943.943 1.886.943 2.829 0l5.04-5.043c.942-.943.942-1.886 0-2.828-.944-.943-1.886-.943-2.83 0l-2.413 2.414c-.472.471-.943.471-1.415 0-.471-.472-.471-.943 0-1.414l2.415-2.415zm-5.839 17.15c-1.886 1.886-3.771 1.886-5.657 0-1.885-1.885-1.885-3.77 0-5.656l5.041-5.037c1.886-1.886 3.771-1.886 5.657 0 0 0 .707.707 0 1.414-.472.472-.943.472-1.414 0-.943-.943-1.886-.943-2.829 0l-5.04 5.037c-.943.943-.943 1.886 0 2.828.942.943 1.885.943 2.828 0l2.414-2.414c.471-.471.943-.471 1.414 0 .472.472.472.943 0 1.414l-2.414 2.415z'
  }));
};

exports.default = SvgLink;